import { render, staticRenderFns } from "./dialogConfirm.vue?vue&type=template&id=6f0453e6&scoped=true"
import script from "./dialogConfirm.vue?vue&type=script&lang=js"
export * from "./dialogConfirm.vue?vue&type=script&lang=js"
import style0 from "./dialogConfirm.vue?vue&type=style&index=0&id=6f0453e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0453e6",
  null
  
)

export default component.exports